import { render, staticRenderFns } from "./tornadoCoin.vue?vue&type=template&id=5536a96a&scoped=true"
import script from "./tornadoCoin.vue?vue&type=script&lang=js"
export * from "./tornadoCoin.vue?vue&type=script&lang=js"
import style0 from "./tornadoCoin.vue?vue&type=style&index=0&id=5536a96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536a96a",
  null
  
)

export default component.exports